<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="주문제작 상담">
          <div class="columns is-multiline">
            <div class="column is-full">
              <admin-form-item label="문의 경로">
                <lp-radio :val.sync="value.channel"
                          value_name="value"
                          label_name="label"
                          :data="channelArr"></lp-radio>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="서비스 이름">
                <input class="input"
                       :value="value.service_name"
                       @input="e=> value.service_name = e.target.value"
                       type="text"
                       maxlength="30">
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="서비스 소개">
                 <textarea class="textarea"
                           rows="4"
                           cols="4"
                           v-model="value.content"></textarea>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="제작예산">
                <div class="flex-align">
                  <input class="input"
                         style="width:150px;margin-right:5px"
                         :value="value.account"
                         @input="e=> value.account = parseInt(e.target.value)"
                         type="number">만원
                </div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="희망 소요기간">
                <div class="flex-align">
                <input class="input"
                       style="width:150px;margin-right:5px"
                       :value="value.hope_date"
                       @input="e=> value.hope_date = e.target.value"
                       type="number">개월
                </div>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="참고자료">
                <input-file :value.sync="value.files_ext" @setValue="val=>value.files=val"></input-file>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="서비스 지원환경">
                <lp-radio :val.sync="value.support"
                          value_name="value"
                          label_name="label"
                          :data="supportArr"></lp-radio>
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="신청자 성함">
                <input class="input"
                       :value="value.name"
                       @input="e=> value.name = e.target.value"
                       type="text"
                       maxlength="30">
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="신청자 연락처">
                <input class="input"
                       :value="value.phone"
                       @input="e=> value.phone = e.target.value"
                       type="text"
                       maxlength="30">
              </admin-form-item>
            </div>
            <div class="column is-full">
              <admin-form-item label="신청자 이메일">
                <input class="input"
                       :value="value.email"
                       @input="e=> value.email = e.target.value"
                       type="text"
                       maxlength="100">
              </admin-form-item>
            </div>
          </div>
        </admin-box-item>
      </div>

      <!-- 저장하기 -->
      <div class="btn-group-justify-end" v-if="!$route.query.id">
        <button class="button is-primary" @click="inquiryCreate">저장하기</button>
      </div>
    </div>
  </div>
</template>
<script>
  import InputFile from "../../../module/common/InputFile";
  import LpRadio from "../../../module/common/LpRadio";
  export default {
    name: "ServiceInquiryCreate",
    components: {LpRadio, InputFile},
    created() {
    },
    data() {
      return {
        value: {
          service_name: '',
          content: '',
          account: 0,
          hope_date: 0,
          files: [],
          support: '모바일 웹 단독(PC로 접속 시 모바일 웹 뷰 제공)',
          channel: '전화 문의',
          name: '',
          phone: '',
          email: ''
        },
        supportArr: [
          {label: '모바일 웹 단독(PC로 접속 시 모바일 웹 뷰 제공)', value: '모바일 웹 단독(PC로 접속 시 모바일 웹 뷰 제공)'},
          {label: 'PC 웹 단독(모바일 접속 시 PC 웹 뷰 제공)', value: 'PC 웹 단독(모바일 접속 시 PC 웹 뷰 제공)'},
          {label: 'PC 웹 + 모바일 웹', value: 'PC 웹 + 모바일 웹'},
          {label: 'PC 웹 + 모바일 웹 + 모바일 앱', value: 'PC 웹 + 모바일 웹 + 모바일 앱'}
        ],
        channelArr: [
          {label: '전화 문의', value: '전화 문의'},
          {label: '이메일 문의', value: '이메일 문의'},
          {label: '채널 io 문의', value: '채널 io 문의'},
          {label: '기타채널 문의', value: '기타채널 문의'}
        ],
      }
    },
    methods: {
      // 문의 등록
      inquiryCreate() {
        let err = '';
        if(!this.value.service_name) err='서비스명을 입력하세요.';
        else if(!this.value.content) err='서비스 소개를 입력하세요.';
        else if(!this.value.account) err='제작예산을 입력하세요.';
        else if(!this.value.hope_date) err='희망 소요기간을 입력하세요.';
        else if(!this.value.name) err='신청자 성함을 입력하세요.';
        else if(!this.value.phone) err='신청자 연락처 입력하세요.';
        else if(!this.value.email) err='신청자 이메일 입력하세요.';

        if(err) {
          this.toast(err);
          return;
        }
        this.$axios.post('admin/launchpack/service/inquiry', this.value).then(res=>{
          this.toast('등록되었습니다.')
          this.$router.replace(this.getPath('launchpack/service/inquiry'));
        })
      },
    }
  }
</script>
<style lang="stylus" scoped>
</style>
